import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle, SafeUrl } from '@angular/platform-browser';
import { AppService } from '../core';
import { ImageObject, Images } from '../views/customize/customize.component';
import { sanitizeExternalUrl } from '../shared/safe-url.util';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  standalone: false
})
export class PreviewComponent implements OnInit {
  images: Images = {
    cover: {
      type: 'cover',
      file: undefined,
      url: '',
      defaultURL: '',
      id: 'coverImage',
      isReloadImagePreview: false
    },
    logo: {
      type: 'logo',
      file: undefined,
      url: '',
      defaultURL: '',
      id: 'logoImage',
      isReloadImagePreview: false
    }
  };
  fromIframe = false;
  safeLogoUrl: SafeUrl | string = '';
  safeCoverBackground: SafeStyle | string = '';
  constructor(
    public appService: AppService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.appService.sendPreviewPage(true);
    if (localStorage.getItem('Images')) {
      const img = JSON.parse(localStorage.getItem('Images') as string) as {
        from: string;
        cover: ImageObject;
        logo: ImageObject;
      };
      this.fromIframe = img.from === 'IFRAME';
      if (img && img.cover && img.logo) {
        this.images = { cover: img.cover, logo: img.logo };
        this.refreshSafeBindings();
      }
    }
  }

  // Only http(s) URLs are passed to Angular's sanitizer to mitigate
  // DOM XSS (CWE-79) caused by javascript:/data: URLs from localStorage.
  private refreshSafeBindings(): void {
    const logoUrl = sanitizeExternalUrl(this.images.logo?.url);
    this.safeLogoUrl = logoUrl
      ? this.sanitizer.bypassSecurityTrustUrl(logoUrl)
      : '';

    const coverUrl = sanitizeExternalUrl(this.images.cover?.url);
    this.safeCoverBackground = coverUrl
      ? this.sanitizer.bypassSecurityTrustStyle(`url("${coverUrl}")`)
      : '';
  }

  transform(url: string | ArrayBuffer | null) {
    return url
      ? (this.sanitizer.bypassSecurityTrustResourceUrl(url as string) as string)
      : '';
  }
}
